import { createSlice } from "@reduxjs/toolkit";

export const WhatsAppSlice = createSlice({
  name: "whatsapp",
  initialState: {
    isCheckedWhatsApp: false,
    isWhatsAppInValid: null,
    whatsapp: "",
    whatsappExt: "",
    dropDownAPI: null,
  },
  reducers: {
    setDropDownAPI: (state, action) => {
      state.dropDownAPI = action.payload;
    },
    changeWhatsApp: (state, action) => {
      state.whatsapp = action.payload;
    },
    changeWhatsAppExt: (state, action) => {
      state.whatsappExt = action.payload;
    },
    changeIsCheckedWhatsApp: (state, action) => {
      state.isCheckedWhatsApp = action.payload;
    },
    changeIsWhatsAppInvalid: (state, action) => {
      state.isWhatsAppInValid = action.payload;
    },
  },
});

export const {
  changeWhatsApp,
  changeIsCheckedWhatsApp,
  changeIsWhatsAppInvalid,
  changeWhatsAppExt,
  setDropDownAPI,
} = WhatsAppSlice.actions;
export default WhatsAppSlice.reducer;
